<h1 mat-dialog-title>Algorithm Settings</h1>
<div mat-dialog-content class="form-container">
  <form [formGroup]="settingsForm" class="settings-form">

    <!-- Boolean Settings (Toggle Switches) -->
    <div class="section">
      <h3>Barrier Settings</h3>
      <div class="form-row">
        <ng-container *ngFor="let config of settingConfigs">
          <div *ngIf="config.type === 'boolean'" class="form-field">
            <mat-slide-toggle [formControlName]="config.key">
              {{ config.label }}
            </mat-slide-toggle>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Length Settings -->
    <div class="section">
      <h3>Limits</h3>
      <div class="form-row">
        <ng-container *ngFor="let config of settingConfigs">
          <div *ngIf="config.type === 'integer' && (config.key.includes('Length') || config.key.includes('Cycle') || config.key.includes('Chain'))" class="form-field">
            <label class="field-label">{{ config.label }}</label>
            <mat-form-field appearance="outline" class="full-width">
              <input
                matInput
                type="number"
                [formControlName]="config.key"
                [attr.min]="config.min || 0"
                [attr.max]="config.max || 999"
                step="1"
                [placeholder]="'Enter value'"
              />
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('required')">Required</mat-error>
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('min') && config.min !== undefined">
                Min: {{ config.min }}
              </mat-error>
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('max') && config.max !== undefined">
                Max: {{ config.max }}
              </mat-error>
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('pattern')">Invalid integer</mat-error>
            </mat-form-field>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Age and HLA Settings in one section -->
    <div class="section">
      <h3>Age & HLA Constraints</h3>
      <div class="form-row">
        <ng-container *ngFor="let config of settingConfigs">
          <!-- Age Difference Settings -->
          <div *ngIf="config.type === 'integer' && config.key.includes('AgeDifference')" class="form-field">
            <label class="field-label">{{ config.label }}</label>
            <mat-form-field appearance="outline" class="full-width">
              <input
                matInput
                type="number"
                [formControlName]="config.key"
                [attr.min]="config.min || 0"
                step="1"
                [placeholder]="'Enter value'"
              />
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('required')">Required</mat-error>
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('min') && config.min !== undefined">
                Min: {{ config.min }}
              </mat-error>
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('pattern')">Invalid integer</mat-error>
            </mat-form-field>
          </div>

          <!-- HLA Mismatch Settings -->
          <div *ngIf="config.type === 'integer' && config.key.includes('HLAMismatch')" class="form-field">
            <label class="field-label">{{ config.label }}</label>
            <mat-form-field appearance="outline" class="full-width">
              <input
                matInput
                type="number"
                [formControlName]="config.key"
                [attr.min]="config.min || 0"
                [attr.max]="config.max || 999"
                step="1"
                [placeholder]="'Enter value'"
              />
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('required')">Required</mat-error>
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('min') && config.min !== undefined">
                Min: {{ config.min }}
              </mat-error>
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('max') && config.max !== undefined">
                Max: {{ config.max }}
              </mat-error>
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('pattern')">Invalid integer</mat-error>
            </mat-form-field>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Transplant Limits and Allocation Points in one section -->
    <div class="section">
      <h3>Transplant Limits & Points</h3>
      <div class="form-row">
        <ng-container *ngFor="let config of settingConfigs">
          <!-- Transplant Limits -->
          <div *ngIf="config.type === 'integer' && config.key.includes('TransplantsPerRun')" class="form-field">
            <label class="field-label">{{ config.label }}</label>
            <mat-form-field appearance="outline" class="full-width">
              <input
                matInput
                type="number"
                [formControlName]="config.key"
                [attr.min]="config.min || 0"
                step="1"
                [placeholder]="'Enter value'"
              />
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('required')">Required</mat-error>
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('min') && config.min !== undefined">
                Min: {{ config.min }}
              </mat-error>
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('pattern')">Invalid integer</mat-error>
            </mat-form-field>
          </div>

          <!-- Allocation Points Settings -->
          <div *ngIf="config.key.includes('allocationPoints')" class="form-field">
            <label class="field-label">{{ config.label }}</label>
            <mat-form-field appearance="outline" class="full-width">
              <input
                matInput
                type="number"
                [formControlName]="config.key"
                [attr.min]="config.min || 0"
                [attr.step]="config.step || (config.type === 'decimal' ? '0.1' : '1')"
                [placeholder]="config.type === 'decimal' ? 'Enter decimal value' : 'Enter value'"
              />
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('required')">Required</mat-error>
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('min') && config.min !== undefined">
                Min: {{ config.min }}
              </mat-error>
              <mat-error *ngIf="settingsForm.get(config.key)?.hasError('pattern')">
                Invalid {{ config.type === 'decimal' ? 'decimal' : 'integer' }}
              </mat-error>
            </mat-form-field>
          </div>
        </ng-container>
      </div>
    </div>

  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="!settingsForm.valid">Save</button>
</div>